module.exports = __webpack_public_path__ + "static/media/Brandon.2953a81c.JPG";